import { useRef, useState } from "react";
import { ListGroup } from "react-bootstrap";
import Datepicker from "react-datepicker";

function ReactDatePickerE() {
  const datepickerRef = useRef(null);
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [startDate, setStartDate] = useState(startOfMonth);
  const [endDate, setEndDate] = useState(today);

  const closeCalendar = () => {
    if (datepickerRef.current) {
      datepickerRef.current.setOpen(false);
    }
  };

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleLastMonth = () => {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const end = new Date(today.getFullYear(), today.getMonth(), 0);
    setStartDate(start);
    setEndDate(end);
    closeCalendar();
  };

  const handleThisMonth = () => {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    setStartDate(start);
    setEndDate(end);
    closeCalendar();
  };

  const handleLastWeek = () => {
    const today = new Date();
    const start = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - today.getDay() - 7
    );
    const end = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - today.getDay() - 1
    );
    setStartDate(start);
    setEndDate(end);
    closeCalendar();
  };

  const handleToday = () => {
    const today = new Date();
    setStartDate(today);
    setEndDate(today);
    closeCalendar();
  };

  const handleYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    setStartDate(yesterday);
    setEndDate(yesterday);
    closeCalendar();
  };

  const handleCurrentQuarter = () => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const quarter = Math.floor(currentMonth / 3);
    const start = new Date(today.getFullYear(), quarter * 3, 1);
    const end = new Date(today.getFullYear(), quarter * 3 + 3, 0);
    setStartDate(start);
    setEndDate(end);
    closeCalendar();
  };

  const handlePreviousQuarter = () => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const quarter = Math.floor(currentMonth / 3);
    const prevQuarter = quarter - 1;

    let start, end;
    if (prevQuarter >= 0) {
      start = new Date(today.getFullYear(), prevQuarter * 3, 1);
      end = new Date(today.getFullYear(), prevQuarter * 3 + 3, 0);
    } else {
      // Last quarter of the previous year
      start = new Date(today.getFullYear() - 1, 9, 1);
      end = new Date(today.getFullYear() - 1, 12, 0);
    }

    setStartDate(start);
    setEndDate(end);
    closeCalendar();
  };

  const handleFiscalYear = () => {
    const today = new Date();
    const year =
      today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    const start = new Date(year, 3, 1); // April 1
    const end = new Date(year + 1, 2, 31); // March 31
    setStartDate(start);
    setEndDate(end);
    closeCalendar();
  };

  const handleFiscalPeriod = () => {
    const today = new Date();
    const year =
      today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    const fiscalMonth = (today.getMonth() + 12 - 3) % 12; // Adjust for April-based fiscal year
    const quarter = Math.floor(fiscalMonth / 3);
    const start = new Date(year, quarter * 3 + 3, 1); // +3 to adjust April start
    const end = new Date(year, quarter * 3 + 6, 0); // end of fiscal quarter
    setStartDate(start);
    setEndDate(end);
    closeCalendar();
  };

  return (
    <Datepicker
      ref={datepickerRef}
      popperPlacement="bottom-start"
      selected={startDate}
      onChange={onChange}
      startDate={startDate}
      formatWeekDay={(day) => day.slice(0, 3)}
      calendarContainer={({ children }) => (
        <div className="react-datepicker react-datepicker__predefined-ranges">
          <ListGroup
            variant="flush"
            className="react-datepicker__ranges"
            style={{ width: "100%", height: "250px", overflowY: "auto" }}
          >
            <ListGroup.Item action onClick={handleToday}>
              Today
            </ListGroup.Item>
            <ListGroup.Item action onClick={handleYesterday}>
              Yesterday
            </ListGroup.Item>
            <ListGroup.Item action onClick={handleLastWeek}>
              Last Week
            </ListGroup.Item>
            <ListGroup.Item action onClick={handleLastMonth}>
              Last Month
            </ListGroup.Item>
            <ListGroup.Item action onClick={handleThisMonth}>
              This Month
            </ListGroup.Item>
            <ListGroup.Item action onClick={handleCurrentQuarter}>
              Current Quarter
            </ListGroup.Item>
            <ListGroup.Item action onClick={handlePreviousQuarter}>
              Previous Quarter
            </ListGroup.Item>
            <ListGroup.Item action onClick={handleFiscalYear}>
              Fiscal Year
            </ListGroup.Item>
            <ListGroup.Item action onClick={handleFiscalPeriod}>
              Fiscal Period
            </ListGroup.Item>
          </ListGroup>
          {children}
        </div>
      )}
      showPreviousMonths
      endDate={endDate}
      selectsRange
      dateFormat="MMM dd, yyyy"
      className="form-control"
    />
  );
}

export default ReactDatePickerE;
